import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Control = ({
  id,
  siteConfig,
  siteWideTab,
  pageSpecificTab,
  onClick,
  icon,
  children,
}) => (
  <div className="w-100 text-center">
    <Button
      id={id}
      color="clear"
      className={[
        'no-click-children rounded-pill p-1 border-lg details-control',
        (siteConfig === 'site_wide' ? siteWideTab : pageSpecificTab) === id ? 'border-white active' : '',
      ].join(' ')}
      onClick={onClick}
    >
      <div
        className={[
          'rounded-pill d-flex bg-white text-body px-3 py-2',
          'd-flex align-items-center justify-content-center',
        ].join(' ')}
      >
        <FontAwesomeIcon icon={icon} size="lg" className="me-2" />
        <h6 className="m-0">{children}</h6>
      </div>
    </Button>
  </div>
);

const mapStateToProps = (store) => ({
  siteConfig: store.modals.siteConfig,
  siteWideTab: store.modals.siteWideTab,
  pageSpecificTab: store.modals.pageSpecificTab,
});

export default connect(mapStateToProps)(Control);
